import axios from "axios";

export default function UserRolesService(formData, userId) {
  return axios({
    method: 'post',
    url: process.env.REACT_APP_API_HOST + "/user/" + userId + "/roles",
    data: formData,
    params: {},
    headers: {'Authorization': 'Bearer ' + localStorage.getItem("userToken"), 'App-Network': localStorage.getItem("networkId")}
  });
}
